import React from "react";

const ForgotPassword = () => {
  return (
    <div>
      <h1> Don't know how to do this yet </h1>
    </div>
  )
}

export default ForgotPassword;
